import { createContext, useContext } from 'react';
var TabListContext = /*#__PURE__*/createContext({
  short: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: function onChange() {},
  selectedId: 0
});

var useTabListContext = function useTabListContext() {
  return useContext(TabListContext);
};

export { TabListContext, useTabListContext };
